/**
 * useMetrics — owns GET /api/v1/metrics (the registry catalogue, build-spec §5).
 * TanStack Query + the carried AuthContext token (CD-7: hooks fetch).
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuth } from '../contexts/AuthContext'
import type { CatalogueResponse } from '../types/metrics'
import { ApiError, fetchApi } from './apiFetch'

export function useMetrics(): UseQueryResult<CatalogueResponse, ApiError> {
  const { token } = useAuth()
  return useQuery<CatalogueResponse, ApiError>({
    queryKey: ['metrics-catalogue'],
    queryFn: () => fetchApi<CatalogueResponse>('metrics', token),
    enabled: token !== null,
  })
}
